import React from 'react'
import PropTypes from 'prop-types'
import { Box, Container } from '@chakra-ui/react'
import HTMLWrapper from 'lib/html-wrapper'

const CustomLayoutOne = ({ data, meta, theme, brandColor }) => {
  const titleNode = () => {
    if (!meta.title) return false

    return (
      <Box
        as='h2'
        color={theme.sectionTitleColor}
        fontFamily='heading'
        fontSize='sectionTitle'
        fontWeight='heading'
        mb={4}
      >
        {data.title}
      </Box>
    )
  }

  return (
    <Box
      bg={theme.backgroundColor}
      px={[2, 4, 8, 16]}
    >
      <Box bg={theme.backgroundColor} py={8} px={[4, 4, 0, 0]}>
        <Container maxW='container.lg' mx='auto' px={0}>
          {titleNode()}
          <Box
            color={theme.textColor}
            fontFamily='heading'
            className='html-editor'
          >
            <HTMLWrapper html={`<div style="overflow-x: auto;">${data.content}</div>`} />
          </Box>
        </Container>
      </Box>
      <style jsx global>{`
            :global(.html-editor ul) {
              padding-inline-start: 40px !important;
            }
            :global(.html-editor ol) {
              padding-inline-start: 40px !important;
            }
            :global(.html-editor a) {
              color: ${brandColor} !important;
            }
          `}</style>
    </Box>
  )
}

CustomLayoutOne.propTypes = {
  data: PropTypes.object,
  meta: PropTypes.object,
  theme: PropTypes.object,
  brandColor: PropTypes.string.isRequired
}

export default CustomLayoutOne
